import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// styles
import styles from './SbRespContentModule.scss';

// components
import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

// helpers
import get from 'lodash.get';

const SbRespContentModuleComponent = ({ searchBrowse }) => {
    const description = get(searchBrowse, 'browseContentModule.description');
    const title = get(searchBrowse, 'browseContentModule.title');
    const photo = get(searchBrowse, 'browseContentModule.photo');

    if (!description) {
        return null;
    }

    return (
        <div className={styles.info}>
            <ExpandableContent collapseHeight={240} buttonClassName={styles.button}>
                {photo && <img className={styles.photo} src={photo} />}
                <div className={styles.title}>{title}</div>
                <span
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            </ExpandableContent>
        </div>
    );
};

SbRespContentModuleComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
};

export const SbRespContentModule = createFragmentContainer(SbRespContentModuleComponent, {
    searchBrowse: graphql`
        fragment SbRespContentModule_searchBrowse on SearchBrowseQueryConnection {
            browseContentModule(contentModuleId: $contentModuleId) {
                description
                title
                photo
            }
        }
    `,
});
